<template>
  <button
    class="button label--add smooth button_container-align"
    @click="addLabel"
  >
    <fluent-icon size="16" icon="conversa2-add" viewbox="0 0 16 16" />
    {{ $t('CONTACT_PANEL.LABELS.CONVERSATION.ADD_BUTTON') }}
  </button>
</template>

<script>
export default {
  methods: {
    addLabel() {
      this.$emit('add');
    },
  },
};
</script>

<style lang="scss" scoped>
.label--add {
  margin-bottom: var(--space-smaller);
  margin-right: var(--space-smaller);
}
</style>
